import { chakra } from '@plurall/elo-v3';

import {
  bodyRecipe,
  cellRecipe,
  columnVisibilityRecipe,
  containerRecipe,
  headerCellRecipe,
  headerRecipe,
  headerRowRecipe,
  headerSortableRecipe,
  paginationButtonRecipe,
  paginationControlsRecipe,
  paginationInfoRecipe,
  paginationRecipe,
  paginationTextRecipe,
  rowRecipe,
  searchRecipe,
  sortIndicatorRecipe,
  tableRootRecipe,
  toolbarRecipe,
  wrapperRecipe,
} from './table.recipe';

export const DataTableContainerFactory = chakra('div', containerRecipe);
export const DataTableWrapperFactory = chakra('div', wrapperRecipe);
export const DataTableRootFactory = chakra('table', tableRootRecipe);
export const DataTableHeaderFactory = chakra('thead', headerRecipe);
export const DataTableHeaderRowFactory = chakra('tr', headerRowRecipe);
export const DataTableHeaderCellFactory = chakra('th', headerCellRecipe);
export const DataTableHeaderSortableFactory = chakra('div', headerSortableRecipe);
export const DataTableSortIndicatorFactory = chakra('span', sortIndicatorRecipe);
export const DataTableBodyFactory = chakra('tbody', bodyRecipe);
export const DataTableRowFactory = chakra('tr', rowRecipe);
export const DataTableCellFactory = chakra('td', cellRecipe);
export const DataTableToolbarFactory = chakra('div', toolbarRecipe);
export const DataTableSearchFactory = chakra('div', searchRecipe);
export const DataTableColumnVisibilityContainerFactory = chakra('div', columnVisibilityRecipe);
export const DataTablePaginationFactory = chakra('div', paginationRecipe);
export const DataTablePaginationInfoFactory = chakra('div', paginationInfoRecipe);
export const DataTablePaginationTextFactory = chakra('span', paginationTextRecipe);
export const DataTablePaginationControlsFactory = chakra('div', paginationControlsRecipe);
export const DataTablePaginationButtonFactory = chakra('button', paginationButtonRecipe);
